import type {FC} from 'react';

import {PortableText} from '@/modules/foundation/sanity/portable-text';
import {
	TextHeading,
	textHeadingPortableTextOverrides,
} from '@/modules/page/components/page-head/text-heading';

import type {TextHeadingSchema} from './schema';

interface Props {
	data: TextHeadingSchema;
}

export const TextHeadingContainer: FC<Props> = ({data}) => {
	const {heading, introduction} = data;

	return (
		<TextHeading heading={heading}>
			{introduction && (
				<PortableText
					blocks={introduction}
					overrideClassNames={textHeadingPortableTextOverrides}
				/>
			)}
		</TextHeading>
	);
};
